// Core
import { useState, useEffect } from "react";
import "./App.css";

// Contrib
import { Routes, Route, Navigate, HashRouter } from "react-router-dom";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faQuestionCircle, faSearch, faBorderAll, faList, faArrowRight, faUniversalAccess, faCalendar, faPersonChalkboard, faNetworkWired, faHandshake, faAddressCard, faCircleInfo, faDisplay } from "@fortawesome/free-solid-svg-icons";

// Custom
import Home from "./components/home";
import SearchPage from "./components/searchpage";
import Questions from "./components/questions";
import Question from "./components/question";

library.add(faQuestionCircle, faSearch, faBorderAll, faList, faArrowRight, faUniversalAccess, faCalendar, faPersonChalkboard, faNetworkWired, faHandshake, faAddressCard, faCircleInfo, faDisplay);

function App() {
	const [loadedData, setLoadedData] = useState();

	useEffect(() => {
		fetch("https://search.grants.nih.gov/faq/api/faq/674")
			.then((r) => r.json())
			.then((r) => setLoadedData(r));
	}, []);

	if (!loadedData) return <img src={process.env.PUBLIC_URL + "/assets/loading.gif"} className="spinner" />;

	return (
		<HashRouter>
			<Routes>
				<Route path="/:alphaheader" element={<Questions data={loadedData} />} />
				<Route path="/:alphaheader/:question" element={<Question data={loadedData} />} />
				<Route path="/search/:searchQuery" element={<SearchPage />} />
				<Route path="*" element={<Navigate to="/" replace />} />
				<Route exact path={"/"} element={<Home data={loadedData} />} />
			</Routes>
		</HashRouter>
	);
}

export default App;
